export const TEST_ID = 'sheetHeader';

export const CLOSE_BUTTON_TEST_ID = 'sheetHeaderCloseButton';

export const EYEBROW_TEST_ID = 'sheetHeaderEyebrow';

export const TITLE_TEST_ID = 'sheetHeaderTitle';

export const REGION_TEST_ID = 'sheetHeaderRegion';

export const CLOSE_LABEL = 'Close';

export const EYEBROW_LABEL = 'Selected location';

export const COORDINATE_PRECISION = 5;
